import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import * as _ from 'lodash';
import {getEnergyOutput} from '../../../../../../store/reducers/outputs/energyOutput';
import {getCarbonOutput, getCarbonOutputPercentage} from '../../../../../../store/reducers/outputs/carbonOutput';
import {GameOverResult, getGameOverResults} from '../../../../../../data/data';

interface Props
{
    // carbon_hint: string;
    // energy_hint: string;
    // questions_hint: string;
    // spacebar_hint: string;

    energy: number;
    carbon: number;
}

import './HintsSection.scss';


class HintsSection extends React.Component<Props, null>
{
    constructor(public props: Props)
    {
        super(props);
    }


    getResult = () =>
    {
        const {carbon, energy} = this.props;

        const data: GameOverResult[] = getGameOverResults();

        // console.group('getResult');
        // console.log('current', carbon, energy);
        // console.log('data', data);
        // console.groupEnd();

        return _.find(data, result =>
        {
            const carbon_match: boolean = carbon > result.carbon[0] && carbon < result.carbon[1];
            const energy_match: boolean = energy > result.energy[0] && energy < result.energy[1];

            // console.log('testing', result.carbon, result.energy);
            // console.log('match?', carbon_match && energy_match);


            return carbon_match && energy_match;
        })
    };


    render()
    {
        // const {carbon_hint, energy_hint, questions_hint, spacebar_hint} = this.props;
        // const {carbon, energy_output} = this.props;

        const result: GameOverResult = this.getResult();

        return <div styleName={'hints-section'}>

            <div styleName={'copy'} dangerouslySetInnerHTML={{ __html: result.text }}/>

            {/*<p>carbon hint</p>
            <p>{carbon_hint}</p>

            <p>energy_hint</p>
            <p>{energy_hint}</p>

            <p>questions hint</p>
            <p>{questions_hint}</p>

            <p>spacebar_hint hint</p>
            <p>{spacebar_hint}</p>*/}

            {/*<h4 styleName={'title'}>things you did well at</h4>*/}

            {/*<p styleName={'copy'}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>*/}

            {/*<h4>things you could improve</h4>*/}

            {/*<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>*/}

        </div>;
    }
}


const mapStateToProps = state =>
{
    return {
        energy: getEnergyOutput(state),
        carbon: getCarbonOutputPercentage(state),
        // carbon_hint: getCarbonNeutralGameOverHint(state),
        // energy_hint: getEnergyOutputGameOverHint(state),
        // questions_hint: getQuestionsGameOverHint(state),
        // spacebar_hint: getMiniGameGameOverHint(state),
    }
};


const mapDispatchToProps = dispatch =>
{
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(HintsSection);



// WEBPACK FOOTER //
// ./src/ts/app/screens/game/modals/game-over/score/HintsSection.tsx